import React, { useState, useEffect } from 'react';
import { getClients, getClient, createClient, updateClient, createEventCode, updateEventCode } from '../api/api';

function ClientsAdmin() {
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [showClientForm, setShowClientForm] = useState(false);
  const [showEventForm, setShowEventForm] = useState(false);
  const [editingEvent, setEditingEvent] = useState(null);

  const [clientForm, setClientForm] = useState({ name: '', payment_mode: 'stop' });
  const [eventForm, setEventForm] = useState({ code: '', label: '', category: 'delivered', rate: 0, counted: 1 });

  useEffect(() => {
    fetchClients();
  }, []);

  const fetchClients = async () => {
    try {
      const response = await getClients();
      setClients(response.data);
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  const fetchClientDetails = async (clientId) => {
    try {
      const response = await getClient(clientId);
      setSelectedClient(response.data);
      setEditingEvent(null);
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  const handleCreateClient = async (e) => {
    e.preventDefault();
    try {
      await createClient(clientForm);
      alert('Client créé avec succès !');
      setShowClientForm(false);
      setClientForm({ name: '', payment_mode: 'stop' });
      fetchClients();
    } catch (error) {
      alert('Erreur: ' + (error.response?.data?.error || 'Une erreur est survenue'));
    }
  };

  const handleCreateEvent = async (e) => {
    e.preventDefault();
    try {
      await createEventCode(selectedClient.id, eventForm);
      alert('Code événement créé avec succès !');
      setShowEventForm(false);
      setEventForm({ code: '', label: '', category: 'delivered', rate: 0, counted: 1 });
      fetchClientDetails(selectedClient.id);
    } catch (error) {
      alert('Erreur: ' + (error.response?.data?.error || 'Une erreur est survenue'));
    }
  };

  const handleUpdateEvent = async (eventId, updatedData) => {
    try {
      await updateEventCode(selectedClient.id, eventId, updatedData);
      alert('✅ Tarif mis à jour avec succès !');
      fetchClientDetails(selectedClient.id);
      setEditingEvent(null);
    } catch (error) {
      alert('Erreur: ' + (error.response?.data?.error || 'Une erreur est survenue'));
    }
  };

  const startEditEvent = (event) => {
    setEditingEvent({
      id: event.id,
      code: event.code,
      label: event.label,
      category: event.category,
      rate: event.rate,
      counted: event.counted,
      active: event.active
    });
  };

  const cancelEdit = () => {
    setEditingEvent(null);
  };

  const saveEdit = () => {
    if (editingEvent) {
      handleUpdateEvent(editingEvent.id, editingEvent);
    }
  };

  const categoryLabels = {
    delivered: 'Livré',
    pickup: 'Enlèvement',
    return: 'Retour'
  };

  return (
    <div className="container">
      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
          <h2>⚙️ Paramétrage Clients & Tarifs</h2>
          <button className="btn-primary" onClick={() => setShowClientForm(!showClientForm)}>
            {showClientForm ? 'Annuler' : '+ Nouveau client'}
          </button>
        </div>

        {showClientForm && (
          <form onSubmit={handleCreateClient} style={{ marginBottom: '2rem', padding: '1.5rem', background: '#f8f9fa', borderRadius: '8px' }}>
            <h3>Nouveau client</h3>
            <div className="form-group">
              <label>Nom du client</label>
              <input type="text" value={clientForm.name} onChange={(e) => setClientForm({...clientForm, name: e.target.value})} required />
            </div>
            <div className="form-group">
              <label>Mode de paiement</label>
              <select value={clientForm.payment_mode} onChange={(e) => setClientForm({...clientForm, payment_mode: e.target.value})} required>
                <option value="stop">Au stop</option>
                <option value="parcel">Au colis</option>
              </select>
            </div>
            <button type="submit" className="btn-success">Créer</button>
          </form>
        )}

        <div style={{ display: 'grid', gridTemplateColumns: '300px 1fr', gap: '2rem' }}>
          <div>
            <h3>Liste des clients</h3>
            {clients.map(client => (
              <div
                key={client.id}
                onClick={() => fetchClientDetails(client.id)}
                style={{
                  padding: '1rem',
                  marginBottom: '0.5rem',
                  background: selectedClient?.id === client.id ? '#B8472E' : '#f8f9fa',
                  color: selectedClient?.id === client.id ? 'white' : '#2c3e50',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  transition: 'all 0.3s'
                }}
              >
                <div style={{ fontWeight: 'bold' }}>{client.name}</div>
                <div style={{ fontSize: '0.85rem', opacity: 0.8 }}>
                  {client.payment_mode === 'stop' ? '🎯 Au stop' : '📦 Au colis'}
                </div>
              </div>
            ))}
          </div>

          <div>
            {selectedClient ? (
              <>
                <div style={{ marginBottom: '2rem', padding: '1rem', background: '#e3f2fd', borderRadius: '8px' }}>
                  <h3 style={{ margin: 0 }}>{selectedClient.name}</h3>
                  <p style={{ margin: '0.5rem 0 0 0' }}>
                    Mode: <strong>{selectedClient.payment_mode === 'stop' ? 'Au stop' : 'Au colis'}</strong>
                  </p>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                  <h4>💰 Codes événements & Tarifs</h4>
                  <button className="btn-primary" onClick={() => setShowEventForm(!showEventForm)}>
                    {showEventForm ? 'Annuler' : '+ Nouveau code'}
                  </button>
                </div>

                {showEventForm && (
                  <form onSubmit={handleCreateEvent} style={{ marginBottom: '2rem', padding: '1.5rem', background: '#fff3cd', borderRadius: '8px', border: '2px solid #B9831C' }}>
                    <h4 style={{ marginTop: 0 }}>Nouveau code événement</h4>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                      <div className="form-group">
                        <label>Code</label>
                        <input type="text" value={eventForm.code} onChange={(e) => setEventForm({...eventForm, code: e.target.value})} required placeholder="Ex: COLIS_LIVRE" />
                      </div>
                      <div className="form-group">
                        <label>Libellé</label>
                        <input type="text" value={eventForm.label} onChange={(e) => setEventForm({...eventForm, label: e.target.value})} required placeholder="Ex: Colis livré" />
                      </div>
                      <div className="form-group">
                        <label>Catégorie</label>
                        <select value={eventForm.category} onChange={(e) => setEventForm({...eventForm, category: e.target.value})} required>
                          <option value="delivered">Livré</option>
                          <option value="pickup">Enlèvement</option>
                          <option value="return">Retour</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label>💰 Tarif unitaire (€)</label>
                        <input
                          type="number"
                          step="0.01"
                          value={eventForm.rate}
                          onChange={(e) => setEventForm({...eventForm, rate: e.target.value})}
                          required
                          placeholder="0.00"
                          style={{ fontSize: '1.1rem', fontWeight: 'bold' }}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                        <input
                          type="checkbox"
                          checked={eventForm.counted === 1}
                          onChange={(e) => setEventForm({...eventForm, counted: e.target.checked ? 1 : 0})}
                          style={{width: 'auto', marginRight: '0.5rem'}}
                        />
                        Compter dans l'emport/traité
                      </label>
                    </div>
                    <button type="submit" className="btn-success">✅ Créer le code événement</button>
                  </form>
                )}

                <div style={{ overflowX: 'auto' }}>
                  <table>
                    <thead>
                      <tr>
                        <th>Code</th>
                        <th>Libellé</th>
                        <th>Catégorie</th>
                        <th style={{ minWidth: '150px' }}>💰 Tarif (€)</th>
                        <th>Compté</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedClient.event_codes?.map(event => (
                        <tr key={event.id} style={{ background: editingEvent?.id === event.id ? '#fff3cd' : 'transparent' }}>
                          <td><strong>{event.code}</strong></td>
                          <td>{event.label}</td>
                          <td>{categoryLabels[event.category]}</td>
                          <td>
                            {editingEvent?.id === event.id ? (
                              <input
                                type="number"
                                step="0.01"
                                value={editingEvent.rate}
                                onChange={(e) => setEditingEvent({...editingEvent, rate: parseFloat(e.target.value)})}
                                style={{
                                  width: '100%',
                                  padding: '0.5rem',
                                  fontSize: '1.1rem',
                                  fontWeight: 'bold',
                                  border: '2px solid #B8472E',
                                  borderRadius: '4px'
                                }}
                              />
                            ) : (
                              <span style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#27ae60' }}>
                                {event.rate.toFixed(2)} €
                              </span>
                            )}
                          </td>
                          <td>
                            {editingEvent?.id === event.id ? (
                              <input
                                type="checkbox"
                                checked={editingEvent.counted === 1}
                                onChange={(e) => setEditingEvent({...editingEvent, counted: e.target.checked ? 1 : 0})}
                              />
                            ) : (
                              event.counted ? '✅' : '❌'
                            )}
                          </td>
                          <td>
                            {editingEvent?.id === event.id ? (
                              <div style={{ display: 'flex', gap: '0.5rem' }}>
                                <button
                                  onClick={saveEdit}
                                  className="btn-success"
                                  style={{ padding: '0.5rem 1rem', fontSize: '0.9rem' }}
                                >
                                  ✅ Valider
                                </button>
                                <button
                                  onClick={cancelEdit}
                                  className="btn-danger"
                                  style={{ padding: '0.5rem 1rem', fontSize: '0.9rem' }}
                                >
                                  ❌ Annuler
                                </button>
                              </div>
                            ) : (
                              <button
                                onClick={() => startEditEvent(event)}
                                className="btn-primary"
                                style={{ padding: '0.5rem 1rem', fontSize: '0.9rem' }}
                              >
                                ✏️ Modifier
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {selectedClient.event_codes?.length === 0 && (
                  <div style={{ textAlign: 'center', padding: '2rem', color: '#999' }}>
                    <p>Aucun code événement configuré.</p>
                    <p>Cliquez sur "+ Nouveau code" pour en ajouter.</p>
                  </div>
                )}
              </>
            ) : (
              <div style={{ textAlign: 'center', color: '#999', padding: '3rem' }}>
                <p style={{ fontSize: '1.2rem' }}>👈 Sélectionnez un client pour voir ses tarifs</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClientsAdmin;
